module.exports = __webpack_public_path__ + "static/img/7.60c810f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/7.png
// module id = QEE5
// module chunks = 0